import { Form, Input, Row, Table } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { AddIcon, EditIcon } from 'assets/svg';
import Button from 'components/Button';
import useQueryParam from 'hooks/useQueryPrams';
import React, { useEffect, useState } from 'react';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { ColumnsType } from 'antd/es/table';
import { useHistory, useLocation } from 'react-router-dom';
import AllocateApi from 'apis/Allocate';
import { useMutation } from 'react-query';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';
import { HocChangePagination } from 'utils/HocChangePagination';
import { useUser } from 'contexts/User';
import FormItem from 'antd/es/form/FormItem';
import { useForm } from 'antd/es/form/Form';
import { SaveFilled } from '@ant-design/icons';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import formatNumber from 'utils/formatNumber';
import CapitalApi from 'apis/CapitalApi';

interface IProps {
  id: number;
  year: number;
  shop_id: any;
}

export default function PlantAllocateTab2(props: IProps) {
  const { id, year, shop_id } = props;
  const { user } = useUser();
  const history = useHistory();
  const [capitalProduct, setCapitalProduct] = useState<any[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [editRowIndex, setEditRowIndex] = useState<number>();
  const queryParam = useQueryParam();
  const [form] = useForm();
  // const [shopId, setShopid] = useState<any>(shop_id);
  // const [yearCapital, setYear] = useState<any>(year);
  // const { state } = useLocation<{
  //   page: number;
  //   page_size: number;
  // }>();

  // const page = state?.page || 1;

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const { mutate: getCapitalProduct, isLoading: isProductLoading } =
    useMutation(
      () =>
        AllocateApi.getRatioCabinet({
          shop_id: shop_id ?? user?.plantId,
          capital_year: year,
          page,
          page_size,
        }),
      {
        onSuccess: (response: any) => {
          if (response.status === STATUS.SUCCESS) {
            setCapitalProduct(response.data);
            setTotal(response.total);
          }
        },
        onError: (error: any) => {
          if (error.response.data.status === 401) {
            handleError401();
          }
        },
      }
    );

  useEffect(() => {
    getCapitalProduct();
  }, [page, page_size, user?.plantId]);

  const cabinetColumn: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'code',
      width: 50,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã tủ',
      dataIndex: 'code',
      width: 80,
    },
    {
      title: 'Tủ Xman trưng bày',
      dataIndex: 'description',
      width: 200,
    },
    // {
    //   title: 'Đơn vị tính',
    //   dataIndex: '',
    //   width: 100,
    // },
    // {
    //   title: 'Số lượng tủ/cây/khay kỳ trước',
    //   dataIndex: 'sl_tu_cay_khay_ky_truoc',
    //   width: 220,
    // },
    {
      title: 'Số lượng tủ',
      dataIndex: 'total_cabinet',
      width: 100,
    },
    // {
    //   title: 'Số lượng bán / tuần (Món)',
    //   dataIndex: 'doanh_so_tuan',
    //   width: 150,
    // },
    // {
    //   title: 'Doanh thu/tuần',
    //   dataIndex: 'doanh_thu_tuan',
    //   width: 150,
    //   render(value, record, index) {
    //     return formatNumber(value);
    //   },
    // },

    // {
    //   title: 'Tỷ trọng SL bán (%)',
    //   dataIndex: 'ty_trong_sl_ban',
    //   width: 150,
    // },
    // {
    //   title: 'Tỷ trọng Doanh thu (%)',
    //   dataIndex: 'ty_trong_doanh_thu',
    //   width: 150,
    // },
    // {
    //   title: 'Số lượng mẫu đăng ký kỳ trước',
    //   dataIndex: 'sl_mau_dang_ky_ky_truoc',
    //   width: 150,
    //   render(value, record, index) {
    //     return formatNumber(value);
    //   },
    // },
    // {
    //   title: 'Sức chứa tối thiểu 1 tủ',
    //   dataIndex: 'suc_chua_toi_thieu_1_tu',
    //   width: 150,
    // },
    // {
    //   title: 'Sức chứa tối đa 1 tủ',
    //   dataIndex: 'suc_chua_toi_da_1_tu',
    //   width: 150,
    // },
    // {
    //   title: 'Sức chứa tối thiểu',
    //   dataIndex: 'suc_chua_toi_thieu',
    //   width: 150,
    // },
    // {
    //   title: 'Sức chứa tối đa',
    //   dataIndex: 'suc_chua_toi_da',
    //   width: 150,
    // },
    // {
    //   title: 'Min kỳ trước',
    //   dataIndex: 'min_ky_truoc',
    //   width: 150,
    // },
    {
      title: 'SL Min kế hoạch',
      dataIndex: 'min_register',
      width: 150,
    },
    // {
    //   title: 'Max đề xuất',
    //   dataIndex: 'max_de_xuat',
    //   width: 150,
    // },
    // {
    //   title: 'Max kỳ trước',
    //   dataIndex: 'max_ky_truoc',
    //   width: 150,
    // },
    {
      title: 'SL Max kế hoạch',
      dataIndex: 'max_register',
      width: 150,
    },
    {
      title: 'Tỷ trọng vốn Max kế hoạch',
      dataIndex: 'ty_trong_von_max_ke_hoach',
      width: 150,
      // render(value, record, index) {
      //   return formatNumber(parseFloat((value ?? 0).toFixed(1)))
      //     .split(',')
      //     .join('.');
      // },
    },
    {
      title: 'Vốn Max kế hoạch',
      width: 150,
      dataIndex: 'von_ke_hoach',
      render(value, record, index) {
        return formatNumber(value);
      },
      // render(value, record, index) {
      //   const data = detailCapitalShop?.capital_ratio_pof.filter(
      //     (item: any) => item.pof_type_code === 'suggest'
      //   );
      //   console.log(data);
      //   const max = (data || [])[0]?.amount_max || 0;
      //   return formatNumber(Math.round(max * record.ty_trong_von_max_ke_hoach));
      // },
    },
    // {
    //   title: 'Vốn max kỳ trước',
    //   dataIndex: 'von_max_ky_truoc',
    //   width: 150,
    //   render(value, record, index) {
    //     return formatNumber(value);
    //   },
    // },
    // {
    //   title: 'Vốn TB 1 mẫu',
    //   dataIndex: 'von_tb_1_mau',
    //   width: 150,
    //   render(value, record, index) {
    //     return formatNumber(value);
    //   },
    // },
    // {
    //   title: 'Vốn dự kiến',
    //   dataIndex: 'von_du_kien',
    //   width: 150,
    //   render(value, record, index) {
    //     return formatNumber(value);
    //   },
    // },
    // {
    //   title: 'Tỷ trọng vốn đề xuất',
    //   dataIndex: 'ty_trong_von_de_xuat',
    //   width: 150,
    // },
    // {
    //   title: 'Vốn kế hoạch',
    //   dataIndex: 'von_ke_hoach',
    //   width: 150,
    //   render(value, record, index) {
    //     return formatNumber(value);
    //   },
    // },
    // {
    //   title: 'Số tuần có thể xuất bán hết SL Min',
    //   dataIndex: 'so_tuan_xuat_ban_het_sl_min',
    //   width: 150,
    // },
    // {
    //   title: 'Số tuần có thể xuất bán hết SL Max',
    //   dataIndex: 'so_tuan_xuat_ban_het_sl_max',
    //   width: 150,
    // },
    // {
    //   title: 'Số tuần có thể xuất bán hết vốn Max',
    //   dataIndex: 'so_tuan_co_the_xuat_ban_het_von_max',
    //   width: 150,
    // },
    {
      fixed: 'right',
      width: 1,
    },
  ];

  // const cabinetColumn: ColumnsType<any> = [
  //   {
  //     title: 'STT',
  //     dataIndex: 'code',
  //     width: 80,
  //     render: (text, record, index) => index + 1 + page_size * (page - 1),
  //   },
  //   {
  //     title: 'Mã tủ',
  //     dataIndex: 'code',
  //     width: 80,
  //     render(value, record, index) {
  //       return index != editRowIndex ? (
  //         <div>{value}</div>
  //       ) : (
  //         <Form.Item name={'code'} style={{ margin: 0 }}>
  //           <Input
  //             defaultValue={value}
  //             style={{ height: '35px', borderRadius: '0px', padding: 4 }}
  //           ></Input>
  //         </Form.Item>
  //       );
  //     },
  //   },
  //   {
  //     title: 'Tủ Xman trưng bày',
  //     dataIndex: 'description',
  //     width: 150,
  //   },
  //   // {
  //   //   title: ' Mô hình kinh doanh',
  //   //   dataIndex: 'model',
  //   //   width: 150,
  //   // },
  //   {
  //     title: 'Hình ảnh',
  //     dataIndex: 'image',
  //     width: 150,
  //     render: (image) => <img style={{ height: 50 }} src={image} />,
  //   },
  //   {
  //     title: 'Số lượng tủ',
  //     dataIndex: 'total_cabinet',
  //     width: 150,
  //   },
  //   {
  //     title: (
  //       <div>
  //         Số lượng Min <br /> đăng ký
  //       </div>
  //     ),
  //     dataIndex: 'min_register',
  //     width: 150,
  //   },
  //   {
  //     title: (
  //       <div>
  //         Số lượng Max <br /> đăng ký
  //       </div>
  //     ),
  //     dataIndex: 'max_register',
  //     width: 150,
  //   },
  //   {
  //     title: 'Chỉnh sửa',
  //     fixed: 'right',
  //     width: 100,
  //     render: (_: any, record: any, index: number) =>
  //       editRowIndex == undefined || editRowIndex != index ? (
  //         <button
  //           onClick={() => {
  //             if (editRowIndex == undefined) {
  //               setEditRowIndex(index);
  //             }
  //             // const values = form.getFieldsValue();
  //             // console.log(values);
  //           }}
  //         >
  //           <EditIcon />
  //         </button>
  //       ) : (
  //         <button
  //           onClick={() => {
  //             if (editRowIndex == index) {
  //               const values = form.getFieldsValue();
  //               console.log(values);
  //               setEditRowIndex(undefined);
  //               form.resetFields();
  //             }
  //           }}
  //         >
  //           <SaveFilled />
  //         </button>
  //       ),
  //   },
  // ];
  return (
    <Content>
      {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Button
          onClick={() => {
            history.push(`/plants-allocate/createCabinet/${id}`);
          }}
        >
          <AddIcon /> Thêm tủ
        </Button>
      </Row> */}
      <Form form={form}>
        <Table
          rowKey={(record) => record.id}
          className="customTable"
          size="small"
          columns={cabinetColumn}
          dataSource={capitalProduct}
          scroll={{ x: 970 }}
          loading={isProductLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Form>
    </Content>
  );
}
